/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_CancelledInputs */

const en_save_cancelled = /** @type {(inputs: Save_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save process cancelled by user`)
};

const fr_save_cancelled = /** @type {(inputs: Save_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processus d'enregistrement annulé par l'utilisateur`)
};

const de_save_cancelled = /** @type {(inputs: Save_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichervorgang vom Benutzer abgebrochen`)
};

const it_save_cancelled = /** @type {(inputs: Save_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio del processo annullato dall'utente`)
};

const ru_save_cancelled = /** @type {(inputs: Save_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Процесс сохранения отменен пользователем`)
};

const es_save_cancelled = /** @type {(inputs: Save_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proceso de guardado cancelado por el usuario`)
};

const zh_cn2_save_cancelled = /** @type {(inputs: Save_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户取消了保存过程`)
};

const ja_save_cancelled = /** @type {(inputs: Save_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存プロセスはユーザーによってキャンセルされました`)
};

const hi_save_cancelled = /** @type {(inputs: Save_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता द्वारा सेव प्रक्रिया रद्द कर दी गई`)
};

const pt_pt2_save_cancelled = /** @type {(inputs: Save_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O processo de salvamento foi cancelado pelo usuário.`)
};

/**
* | output |
* | --- |
* | "Save process cancelled by user" |
*
* @param {Save_CancelledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const save_cancelled = /** @type {((inputs?: Save_CancelledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_CancelledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_save_cancelled(inputs)
	if (locale === "de") return de_save_cancelled(inputs)
	if (locale === "it") return it_save_cancelled(inputs)
	if (locale === "ru") return ru_save_cancelled(inputs)
	if (locale === "es") return es_save_cancelled(inputs)
	if (locale === "zh-CN") return zh_cn2_save_cancelled(inputs)
	if (locale === "ja") return ja_save_cancelled(inputs)
	if (locale === "hi") return hi_save_cancelled(inputs)
	if (locale === "pt-PT") return pt_pt2_save_cancelled(inputs)
	return en_save_cancelled(inputs)
});